import { render, staticRenderFns } from "./LowProfitChip.vue?vue&type=template&id=4355ca5a"
import script from "./LowProfitChip.vue?vue&type=script&lang=js"
export * from "./LowProfitChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports